"use client";

import * as React from "react";

import { Menu } from "@headlessui/react";

import { cn } from "@/shared/helpers/cn.helper";

export type DropdownProps = React.ComponentProps<typeof Menu> & {
  className?: string;
};

const Dropdown = React.forwardRef<HTMLDivElement, DropdownProps>(({ className, ...props }, ref) => {
  return (
    <Menu
      ref={ref}
      as="div"
      className={cn("relative w-fit", className as string)}
      {...props}
    />
  );
});

Dropdown.displayName = "Dropdown";

export { Dropdown };
